package com.bikompanion.data

/**
 * Which upstream the bike data is read from.
 *
 * [CityBikes] is back in use now that debug builds send the `x-api-key` header (see
 * [BuildKonfig][com.bikompanion.data.BuildKonfig]); it covers hundreds of networks worldwide,
 * versus [Gbfs] which only covers whatever is listed in `GbfsSystems` — today Bicing and
 * AMBici — leaving the map empty outside the Barcelona metropolitan area.
 */
enum class BikeDataSource {
    /** api.citybik.es — worldwide, requires the `x-api-key` header. */
    CityBikes,

    /** The operators' own GBFS feeds — Barcelona metropolitan area, published openly. */
    Gbfs,

    ;

    companion object {
        /** Flip to [Gbfs] to go back. */
        val Active: BikeDataSource = CityBikes
    }
}
